import type { ICartPricing } from 'hooks/useDCSTypes';
import { SUBSCRIPTION_STATE } from 'hooks/useSubscriptionsState';
import { InstallmentPlanPricing } from 'services/dcs/bundle';

function getSubscriptionPricing(
  subscriptionsState: SUBSCRIPTION_STATE,
  installmentPlans: InstallmentPlanPricing,
) {
  if (subscriptionsState === SUBSCRIPTION_STATE.ENABLED_36_MONTH) return installmentPlans.SL36?.value;
  if (subscriptionsState === SUBSCRIPTION_STATE.ENABLED_48_MONTH) return installmentPlans.SL48?.value;
  return undefined;
}

export const calculateSubscriptionMonthlyPrice = (
  subscriptionState: SUBSCRIPTION_STATE,
  installmentPlans: InstallmentPlanPricing,
  softwarePlanMonthlyPrice: number,
) => {
  const subscriptionPrice = getSubscriptionPricing(subscriptionState, installmentPlans);
  return subscriptionPrice ? Math.ceil(subscriptionPrice + softwarePlanMonthlyPrice) : 0;
};

interface IPricingData {
  msrpPrice: number;
  upfrontPrice: number;
  softwarePlanMonthlyPrice: number;
}

export const getPricingData = (pricing: ICartPricing, showSoftwareMonthlyPlan = true): IPricingData => {
  const { basePrice, msrp, monthlyAdditionalPrice } = pricing;

  return {
    msrpPrice: msrp?.value ?? 0,
    upfrontPrice: basePrice.value,
    softwarePlanMonthlyPrice: showSoftwareMonthlyPlan ? monthlyAdditionalPrice.value : 0,
  };
};
